import { getThemeMode, setThemeMode, themeLabel, THEME_MODES, type ThemeMode } from './Theme';

const MUTE_KEY = 'knytt-muted';

export function isMuted(): boolean {
  try {
    return localStorage.getItem(MUTE_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * The shared settings rows (mute-audio checkbox + theme select), used by the
 * menu's Settings screen and the in-game pause panel. Persistence lives here
 * (localStorage 'knytt-muted' / Theme.ts); onMuteChange only has to apply the
 * new state to whichever audio backend is live (menu <audio> / AudioManager).
 */
export function buildSettingsRows(onMuteChange: (muted: boolean) => void): HTMLDivElement {
  const el = document.createElement('div');
  el.className = 'settings-rows';
  const mode = getThemeMode();
  el.innerHTML = `
    <label class="settings-row"><input type="checkbox" class="set-mute" ${isMuted() ? 'checked' : ''}/> Mute audio</label>
    <label class="settings-row">Theme
      <select class="set-theme">
        ${THEME_MODES.map((m) => `<option value="${m}" ${m === mode ? 'selected' : ''}>${themeLabel(m)}</option>`).join('')}
      </select>
    </label>`;
  const mute = el.querySelector('.set-mute') as HTMLInputElement;
  mute.addEventListener('change', () => {
    try {
      localStorage.setItem(MUTE_KEY, mute.checked ? '1' : '0');
    } catch {
      /* localStorage unavailable */
    }
    onMuteChange(mute.checked);
  });
  const theme = el.querySelector('.set-theme') as HTMLSelectElement;
  theme.addEventListener('change', () => setThemeMode(theme.value as ThemeMode));
  return el;
}
